import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=fe7f987e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=fe7f987e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7f987e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe7f987e')) {
      api.createRecord('fe7f987e', component.options)
    } else {
      api.reload('fe7f987e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=fe7f987e&scoped=true&", function () {
      api.rerender('fe7f987e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25VvQ4XLo07p7/JS/comp/PopupBox.vue"
export default component.exports